// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "a8a7529f0cf2cc61bbf8" + ".chunk.js";
};